import React from 'react';
import { Logo } from 'components/common';

const SsoLayout = ({
  children,
  minHeight = '520px', // Reserve minimum height to prevent shifts
  showLogo = true,
}) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f6f8fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <div
        style={{
          minWidth: 400,
          maxWidth: 520,
          width: '100%',
          minHeight, // Fixed minimum height prevents layout shifts
          margin: '0 auto',
          padding: '3rem 3rem',
          borderRadius: 12,
          background: '#fff',
          boxShadow:
            '0 4px 24px rgba(0,0,0,0.10), 0 1.5px 4px rgba(0,0,0,0.08)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        {showLogo && <Logo />}
        <div
          style={{
            flex: 1,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center', // Center content vertically within the fixed height
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default SsoLayout;
